function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "Layer_2_25_"
}, /*#__PURE__*/React.createElement("path", {
  d: "M372.816,322.828c-60.436-21.786-79.748-10.809-79.748-50.174c0-1.879,0.119-5.41,0.34-9.022h2.957 c41.301,3.012,81.092,5.89,89.947-0.301c14.143-9.88-34.811-25.105-34.811-152.92c0-64.582-42.562-110.41-107.145-110.41 c-0.549,0-1.088,0.033-1.629,0.043c-0.152-0.004-0.307-0.006-0.455-0.014V0.018c-0.242,0-0.484-0.018-0.727-0.018 c-0.076,0-0.15,0.004-0.227,0.004c-0.073,0-0.146-0.004-0.223-0.004c-0.071,0-0.142,0.004-0.213,0.006 C240.812,0.004,240.741,0,240.67,0c-0.076,0-0.149,0.004-0.223,0.004c-0.076,0-0.15-0.004-0.227-0.004 c-0.242,0-0.484,0.018-0.727,0.018V0.03c-0.149,0.008-0.303,0.01-0.455,0.014c-0.542-0.01-1.081-0.043-1.629-0.043 c-64.581,0-107.145,45.828-107.145,110.41c0,127.814-48.951,143.041-34.811,152.92c8.856,6.188,48.647,3.312,89.948,0.301h2.958 c0.22,3.612,0.338,7.146,0.338,9.022c0,39.365-19.313,28.388-79.747,50.174c-60.62,21.863-78.095,44.152-78.095,59.355 c0,15.181,0,99.58,0,99.58h209.438h0.302h0.286h0.286h0.302h209.439c0,0,0-84.399,0-99.58 C450.91,366.982,433.436,344.693,372.816,322.828z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgWoman = function SvgWoman(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "481.764px",
    height: "481.764px",
    viewBox: "0 0 481.764 481.764",
    style: {
      enableBackground: "new 0 0 481.764 481.764"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWoman, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/woman.db9222a1.svg";
export { ForwardRef as ReactComponent };